import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FormState } from 'react-hook-form';
import { useAllClubsQuery } from '../queries';
import { Input } from '~/components/Input';

interface Props<TFormState extends BaseFormState> {
  onChange?: (values: number[]) => void;
  formState?: FormState<TFormState>;
  placeholder?: string;
  disabled?: boolean;
  value?: number[];
}

function ClubMultiSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useAllClubsQuery();

  return (
    <Input.MultiSelect
      placeholder={props.placeholder ?? 'Välj en eller flera föreningar'}
      options={data.map(o => [o.name, o.id])}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      aria-label="Sök förening"
      ref={ref}
      {...props}
    />
  );
}

export const ClubMultiSelect = forwardRef(ClubMultiSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof ClubMultiSelectElement>;
